import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { CreateCourt, UpdateCourt } from "../../../types";
import { queryKeys } from "../../query-keys";

export function useCourts(locationId: string) {
	return useQuery({
		queryKey: queryKeys.locations.courts(locationId),
		queryFn: () => adminApi.courts.list(locationId),
		enabled: !!locationId,
	});
}

export function useCreateCourt(locationId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: CreateCourt) => adminApi.courts.create(locationId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.locations.courts(locationId),
			}),
	});
}

export function useUpdateCourt(locationId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ courtId, data }: { courtId: string; data: UpdateCourt }) =>
			adminApi.courts.update(locationId, courtId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.locations.courts(locationId),
			}),
	});
}

export function useDeleteCourt(locationId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (courtId: string) => adminApi.courts.delete(locationId, courtId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.locations.courts(locationId),
			}),
	});
}
